import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";

function AddTrack({ open, onClose, initialData, onSubmit }) {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      tracking_number: initialData ? initialData.tracking_number : "",
    },
    validationSchema: Yup.object({
      tracking_number: Yup.string().required("Tracking number is required"),
    }),
    onSubmit: async (values) => {
      const errors = await formik.validateForm();
      if (Object.keys(errors).length) return; // prevent submit if there are errors
      await onSubmit(values);
      handleCancel();
    },
  });

  const handleCancel = () => {
    formik.setValues({
      tracking_number: "",
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {initialData ? "Update Tracking Number" : "Add Tracking Number"}
      </DialogTitle>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent dividers>
          <TextField
            name="tracking_number"
            label="Track Order Number"
            value={formik.values.tracking_number}
            onChange={formik.handleChange}
            error={
              formik.touched.tracking_number &&
              Boolean(formik.errors.tracking_number)
            }
            helperText={
              formik.touched.tracking_number && formik.errors.tracking_number
            }
            fullWidth
            margin="normal"
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCancel} color="secondary">
            Cancel
          </Button>
          <Button type="submit" color="primary" variant="contained">
            {initialData ? "Update" : "Submit"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default AddTrack;
